module.exports = __webpack_public_path__ + "img/anonymous-image.a0cb40fd.png";